export default __webpack_public_path__ + "static/media/matt-robinson.4aad707c.jpeg";